export default "__VITE_ASSET__DrfUvAlu__"